import { Ionicons } from '@expo/vector-icons';
import * as Clipboard from 'expo-clipboard';
import { usePathname } from 'expo-router';
import { Share, TouchableOpacity, TouchableOpacityProps } from 'react-native';
import { StyleSheet } from 'react-native';
import Toast from 'react-native-toast-message';

import { createShortDeepLink } from '@/utils/createDeepLink';
import { i18n } from '@/utils/i18n';

interface ShareButtonProps extends TouchableOpacityProps {
  iconSize?: number;
  variant?: 'default' | 'rounded';
  shareThumb?: string;
}

const ShareButton = ({ iconSize = 18, variant = 'default', shareThumb, ...props }: ShareButtonProps) => {
  const pathname = usePathname();
  const styles = useStyle(iconSize);

  const getVariantStyle = (variant: 'default' | 'rounded') => {
    switch (variant) {
      case 'rounded':
        return styles.roundedIcon;

      default:
        return styles.default;
    }
  };

  const handleShare = async () => {
    const deepLink = await createShortDeepLink(pathname, shareThumb);
    Share.share({
      message: deepLink ?? ''
    }).catch((shareError) => {
      console.warn('Share Failed, coping to clipboard...', shareError);
      Clipboard.setStringAsync(deepLink ?? '')
        .then(() => {
          Toast.show({
            type: 'success',
            text1: i18n.t('mix.copied.title'),
            text2: i18n.t('mix.copied.link'),
            position: 'bottom',
            visibilityTime: 2000
          });
        })
        .catch((clipboardError) => {
          console.error(clipboardError);
        });
    });
  };

  return (
    <TouchableOpacity {...props} onPress={handleShare}>
      <Ionicons size={iconSize} name="share-outline" style={getVariantStyle(variant)} />
    </TouchableOpacity>
  );
};

const useStyle = (iconSize: number) => {
  const styles = StyleSheet.create({
    default: {
      color: 'black',
      backgroundColor: 'white',
      padding: 8
    },

    roundedIcon: {
      color: 'black',
      backgroundColor: 'white',
      //(Size + Padding + BorderWidth) / 2
      borderRadius: (iconSize + 16) / 2,
      padding: 8,
      overflow: 'hidden'
    }
  });

  return styles;
};

export default ShareButton;
